/**
 * Shared spacing classes for PageBuilder sections
 */

export const topSpacingClasses = {
  default: 'mt-8xl lg:mt-12xl',
  large: 'mt-10xl lg:mt-14xl',
  half: 'mt-4xl lg:mt-6xl',
  none: 'mt-0',
} as const

export const bottomSpacingClasses = {
  default: 'mb-8xl lg:mb-12xl',
  large: 'mb-10xl lg:mb-14xl',
  half: 'mb-4xl lg:mb-6xl',
  none: 'mb-0',
} as const

/**
 * Get top spacing class based on spacing value
 */
export function getTopSpacingClass(spacing: string | null | undefined): string {
  return (
    topSpacingClasses[(spacing as keyof typeof topSpacingClasses) || 'default'] ||
    topSpacingClasses.default
  )
}

/**
 * Get bottom spacing class based on spacing value
 */
export function getBottomSpacingClass(spacing: string | null | undefined): string {
  return (
    bottomSpacingClasses[(spacing as keyof typeof bottomSpacingClasses) || 'default'] ||
    bottomSpacingClasses.default
  )
}
